/**
 * IMPORTANT!!!!!!!!!
 * When updating this file you need to make sure the API Platform file to reflect this file very accurately.
 * You can find the file at "/api/src/Constants/Permissions.php
 */

// Billing
export const MANAGE_HEALTH_CARE_SERVICES = 'manage_health_care_services';

// Account Settings
export const MANAGE_ACCOUNT = 'manage_account';
export const MANAGE_TEMPLATES = 'manage_templates';
export const MANAGE_PROGRAMS = 'manage_programs';
export const MANAGE_USERS = 'manage_users';
export const MANAGE_ROLES = 'manage_roles';
export const MANAGE_WORKBOARDS = 'manage_workboards';
export const VIEW_GENERAL_LOG = 'view_general_log';
export const ADMISSIONS_ACCESS = 'admissions_access';
export const EDIT_ACCOUNT_REPORTS = 'edit_account_reports';
export const MANAGE_CARE_TEAM_DEPARTMENTS = 'manage_care_team_departments';

// Contact
export const MANAGE_ENCOUNTERS = 'manage_encounters';
export const MANAGE_DOCUMENTATION = 'manage_documentation';
export const ADD_CONTACTS = 'contact_add';
export const EDIT_CONTACTS = 'contact_edit';
export const MANAGE_CONTACTS_EOC_PROGRAMS = 'contact_manage_eoc_programs';
export const MANAGE_CARE_TEAMS = 'contact_manage_care_teams';
export const MANAGE_INSURANCE_COVERAGE = 'contact_manage_ins_coverage';
export const REQUEST_ELIGIBILITY_CHECK = 'request_eligibility_check';
export const UNLOCK_NOTES = 'contact_unlock_forms';
export const MANAGE_FILES = 'contact_manage_files';
export const DELETE_FILES = 'contact_delete_files';
export const VIEW_MED_LIST = 'view_med_list';
export const UPDATE_MED_LIST = 'update_med_list';
export const ADMINISTER_MEDICATIONS = 'administer_medications';
export const VIEW_OUTCOMETOOLS = 'view_outcometools';
export const PERSPECTIVES_ACCESS = 'perspectives_access';
export const HOST_TELEHEALTH_SESSIONS = 'host_telehealth_sessions';
export const CALENDAR_SUBSCRIPTION = 'calendar_subscription';
export const LENS_VIEW = 'lens_view';
export const LENS_BUILD = 'lens_build';
export const LENS_MANAGE_ALL = 'lens_manage_all';
export const PATIENT_RISK_FLAGS = 'patient_risk_flags';
export const SET_AND_CLEAR_PATIENT_RISK_FLAGS = 'set_and_clear_patient_risk_flags';

export const MANAGE_PRIOR_AUTHORIZATIONS = 'manage_prior_authorizations';
// Diagnosis
export const VIEW_DIAGNOSIS = 'view_diagnosis';
export const MANAGE_DIAGNOSIS = 'manage_diagnosis';
export const VIEW_PROBLEM_TREATMENT_PLAN = 'view_problem_treatment_plan';
export const MANAGE_PROBLEM_TREATMENT_PLAN = 'manage_problem_treatment_plan';
export const DSM5_ACCESS = 'dsm5_access';
export const VIEW_ALLERGIES = 'view_allergies';
export const MANAGE_ALLERGIES = 'manage_allergies';
export const MANAGE_TREAMENT_GROUPS = 'manage_treatment_groups';
export const MANAGE_ASAM4 = 'manage_asam4';

// Financial/Claims
export const VIEW_CLAIMS = 'view_claims';
export const EDIT_CLAIMS = 'edit_claims';
export const SUBMIT_CLAIMS = 'submit_claims';
export const ACCEPT_PAYMENTS = 'accept_payments';

// Messaging
export const MESSAGE_WITH_CLIENTS = 'message_with_clients';
export const MESSAGE_WITH_OTHER_USERS = 'message_with_other_users';

// BnSupport Roles
export const BN_SUPPORT_DB_ACCESS = 'db_access';
export const BN_SUPPORT_MANAGE_USERS = 'manage_bn_support_users';
export const BN_SUPPORT_CREATE_DATABASE = 'create_database';
export const BN_SUPPORT_FRESHDESK_TRIAGE = 'freshdesk_triage';
export const BN_SUPPORT_EXPORT_DATA = 'export_data';
export const BN_SUPPORT_LENS_OOTB_BUILD = 'lens_ootb_build';
export const BN_SUPPORT_SUSPEND_ACCOUNTS = 'suspend_accounts';
export const BN_SUPPORT_MANAGE_FEATURE_FLAGS = 'manage_feature_flags';
export const BN_SUPPORT_MANAGE_LOGIN_ADS = 'manage_login_ads';
